module.exports = __webpack_public_path__ + "static/media/questionMark.a0f413b5.svg";